module.exports = __webpack_public_path__ + "static/media/Dark_analytics.af895ffc.png";